import * as produitConf from '@/configuration/catalogue/produitConf';
import { TYPE_COMMANDE } from '@/configuration/devisConf';
import dateRenouvellementGenerator from '@/services/devisCommandes/dateRenouvellementGenerator';

export default function categorieVenteInitialize(dcf) {
  if (dcf.categorieVente !== null
      && dcf.categorieVente !== produitConf.CATEGORIE_DIVERS) return;
  const ligne = dcf.lignesCommande.find((ligne) => {
    return ligne.typeProduit && ligne.typeProduit !== produitConf.CATEGORIE_DIVERS;
  });
  if (ligne) dcf.categorieVente = ligne.typeProduit;
  else dcf.categorieVente = produitConf.CATEGORIE_DIVERS;
  if (dcf.type === TYPE_COMMANDE && dcf.categorieVente === produitConf.CATEGORIE_UNITAIRE) {
    dcf.renouvelable = true;
    dcf.reconductible = true;
    dateRenouvellementGenerator(dcf);
  }
}
